/* eslint-disable camelcase */
import React from 'react'
import { Col, Row, Typography } from 'antd'
import PropTypes from 'prop-types'

import { HeroImageUploader } from '~components'
import { Input } from '~stories'

import styles from './UniversalTemplateFields.module.css'

const { Text } = Typography

const UniversalTemplateHeroFields = ({ hero, onChange }) => {
  const { img = '', url = '', alt = '' } = hero || {}

  const patch = updates => onChange({ ...hero, ...updates })

  return (
    <div className={styles.fieldGroup}>
      <div className={styles.fieldRow}>
        <Text className={styles.fieldLabel}>Image</Text>
        <div className={styles.imageUploaderWrapper}>
          <HeroImageUploader
            handleUpload={(thumbnailImageUrl, secureImageURL) => {
              const imageUrl = secureImageURL || thumbnailImageUrl
              patch({ img: imageUrl })
            }}
            logoUrl={img}
          />
        </div>
      </div>

      <hr className={styles.sectionDivider} />

      <Row gutter={[24, 0]}>
        <Col span={12}>
          <div className={styles.fieldRow}>
            <Text className={styles.fieldLabel}>URL</Text>
            <Input
              onChange={e => patch({ url: e.target.value })}
              placeholder="https://example.com"
              value={url}
            />
            <Text className={styles.hint}>Link destination when image is clicked</Text>
          </div>
        </Col>
        <Col span={12}>
          <div className={styles.fieldRow}>
            <Text className={styles.fieldLabel}>Alt text</Text>
            <Input
              onChange={e => patch({ alt: e.target.value })}
              placeholder="Describe the image"
              value={alt}
            />
            <Text className={styles.hint}>Shown if image fails to load (accessibility)</Text>
          </div>
        </Col>
      </Row>
    </div>
  )
}

UniversalTemplateHeroFields.propTypes = {
  hero: PropTypes.object,
  onChange: PropTypes.func.isRequired
}

export default UniversalTemplateHeroFields
